<template>
    <div class="main bar"
         :style="{ background: bgcolor, color: color }">
        <div class="left-menu">
            <img :src="logopath" id="logo-img">
        </div>
        <div class="right-menu">
            <div class="content">
                <button class="btn btn-success"
                    v-if="!$auth.isAuthenticated()"
                    @click="login()"
                >
                    Kirjaudu
                </button>

                <button class="btn btn-danger"
                    v-if="$auth.isAuthenticated()"
                    @click="logout()"
                >
                    Poistu
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Authentication',
        methods: {
            login: function() {
                this.$auth.login();
            },
            logout: function() {
                this.$auth.logout().then((lock) => {

                    this.$store.dispatch('changeTheme', { theme: {}});
                    let returnUrl = window.location.href;
                    lock.logout({
                        returnTo: returnUrl
                    })
                });
            }

        },
        computed: {
            logopath: function() {
                let logo_path = this.$store.state.theme.logoUrl;
                if (!logo_path) {
                    return require('../../../assets/img/cropped-Integral_logo.png');
                }
                return logo_path;
            },
            bgcolor: function() {
                return this.$store.getters.mainbg;
            },
            color: function() {
                return this.$store.getters.maintext;
            }
        }
    }

</script>

<style>
    .main.bar {
        width: 100%;
        box-shadow: 0 0 5px 1px #333;
        max-height: 68px;
        background: white;
        display: flex;
        z-index: 9999;
    }
    .main.bar img {
        display: block;
        height: auto;
        width: auto;
        max-height: 100%;
        max-width: 100%;
    }
    .right-menu {
        text-align: right;
        flex: 1;
    }
    .left-menu {
        flex: 1;
    }
</style>



// WEBPACK FOOTER //
// src/app/Main/components/Authentication.vue